import { render, staticRenderFns } from "./index.vue?vue&type=template&id=37fa5daa&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=37fa5daa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fa5daa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer-copy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37fa5daa')) {
      api.createRecord('37fa5daa', component.options)
    } else {
      api.reload('37fa5daa', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=37fa5daa&scoped=true", function () {
      api.rerender('37fa5daa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/copyright/index.vue"
export default component.exports